module.exports = __webpack_public_path__ + "img/appLogo-color--Onlight.4432a35b.svg";